"use strict";

var EHDI = EHDI || Object.create(null);

// Create Main Module and scenes if not yet initialized
var Main = Main || Object.create(null);

// Main onResize function
Main.onResize = function () {
    if (!Main.canvas) return;
    // New code from MC
    Main.vendorGameElement.style.width = Math.min(document.documentElement.clientWidth, window.innerWidth || 0);
    Main.vendorGameElement.style.height = Math.min(document.documentElement.clientHeight, window.innerHeight || 0);
    // End new code

    // Initialize needed values
    var _width = APP.managers.scene.defaultWidth,
        _height = APP.managers.scene.defaultHeight,
        _scaleX = Main.vendorGameElement.offsetWidth / APP.managers.scene.defaultWidth,
        _scaleY = Main.vendorGameElement.offsetHeight / APP.managers.scene.defaultHeight,
        // _scaleX = Main.vendorGameElement.offsetWidth / APP.managers.scene.defaultWidth,
        // _scaleY = window.innerHeight / APP.managers.scene.defaultHeight,
        _ratio = Math.min(_scaleX, _scaleY);

    // Compute width and height
    _width = Math.ceil(_width * _ratio);
    _height = Math.ceil(_height * _ratio);

    // Set stage scale
    APP.display.stage.scale.x = APP.display.stage.scale.y = _ratio;

    // console.log(_ratio + " ratio");
    // console.log(document.documentElement.clientWidth + " width doc" + " " + document.documentElement.clientHeight + " height doc");
    // console.log(window.innerWidth + " width window" + " " + window.innerHeight + " height window");
    // Resize renderer
    APP.display.renderer.resize(_width, _height);

    // Set canvas properties
    APP.display.canvas.style.paddingLeft = 0;
    APP.display.canvas.style.paddingRight = 0;
    APP.display.canvas.style.paddingTop = 0;
    APP.display.canvas.style.paddingBottom = 0;
    APP.display.canvas.style.display = "block";
    APP.display.canvas.style.position = "absolute";
    APP.display.canvas.style.top = 0;
    APP.display.canvas.style.left = 0;
    APP.display.canvas.style.right = 0;
    APP.display.canvas.style.bottom = 0;

    // Adjust margins according to the following
    var _margin;
    if (_width < Main.vendorGameElement.offsetWidth) {

        // Compute margin
        _margin = (Main.vendorGameElement.offsetWidth - _width) / 2;

        // Set left and right margins
        APP.display.canvas.style.left = _margin + "px";
        APP.display.canvas.style.right = _margin + "px";
    }
    // if (_height < window.innerHeight) {
    //     // Compute margin
    //     _margin = (window.innerHeight - _height) / 2;

    //     // Set top and bottom margins
    //     APP.display.canvas.style.top = _margin + "px";
    //     APP.display.canvas.style.bottom = _margin + "px";
    // }
    if (_height < Main.vendorGameElement.offsetHeight) {

        // Compute margin
        _margin = (Main.vendorGameElement.offsetHeight - _height) / 2;

        // Set top and bottom margins
        APP.display.canvas.style.top = _margin + "px";
        APP.display.canvas.style.bottom = _margin + "px";
    }

    // Scroll to 0, 0
    window.scrollTo(0, 0);
};

// Main onInit function
function GameInit(gameType, gameElement, gameLevelComplete, gameEndFunction, gameData, pracPlay, htpShow, previousScore) {

    // Not needed anymore since game will be standalone
    EHDI.urlParams = { type: "sepa" }

    EHDI.GAME.constants = EHDI.GAME.constants || Object.create(null);
    Object.defineProperties(EHDI.GAME.constants,
        {
            'boundHeight': { value: APP.config.stageWidth },
            'boundWidth': { value: APP.config.stageHeight },
            'singleGametimelimit': { value: 60600 },
            'multiTime': { value: 180600 },
            'gameType': { value: gameType },
            'gameData': { value: gameData },
            'previousScore': { value: previousScore },
            'pracPlay': { value: pracPlay },
            'gameEndFunction': { value: gameEndFunction },
            'gameLevelComplete': { value: gameLevelComplete },
            'htpShow': { value: htpShow }
        }
    );

    // Initialize scene manager instance
    APP.managers.scene = EHDI.SceneManager(APP.config.stageWidth, APP.config.stageHeight);

    // Initialize display values for renderer and stage
    APP.display.renderer = APP.managers.scene.getRenderer();
    APP.display.stage = APP.managers.scene.getStage();
    APP.display.canvas = APP.display.renderer.view;

    if (PIXI.VERSION[0] == '5') {
        Main.canvas = APP.display.renderer.view;
        Main.canvas.id = "game-canvas";
        Main.canvas.width = Main.vendorGameElement.style.width;
        Main.canvas.height = Main.vendorGameElement.style.height;
        Main.vendorGameElement.appendChild(Main.canvas);
    }

    // Initialize event manager
    APP.managers.event = EHDI.EventManager();
    APP.managers.event.maxListeners = APP.config.maxListeners;

    // Initialize load manager
    APP.managers.load = EHDI.LoadManager;

    // Initialize sound manager
    APP.managers.sound = EHDI.SoundManager(true);

    // Initialize storage manager
    APP.managers.storage = EHDI.StorageManager();

    // Initialize update manager
    APP.managers.update = EHDI.UpdateManager(APP.display.renderer, APP.display.stage);

    // Get save data and store to SB reference
    APP.save = APP.managers.storage.getLocalInfo(APP.config.id) || { isMuted: false, isFirstTimePlay: true, highscore: 0 };
    if (typeof APP.save.highscore === "undefined") APP.save.highscore = 0;
    APP.managers.storage.setLocalInfo(APP.config.id, APP.save);

    // Set sound manager default mute state
    APP.managers.sound.setMute(APP.save.isMuted);

    // Set debug version
    APP.config.debugEnabled = true;

    // Set game version
    APP.config.version = "v.1.0.0";

    // Initialize scale manager -- Disabled for Superbook
    // APP.managers.scale = EHDI.ScaleManager( APP.display.renderer, APP.display.stage,
    //                                         EHDI.ScaleManager.DOCKING.AUTO, APP.config.stageWidth, APP.config.stageWidth );
    // APP.managers.scale.addAutomaticScaling();

    // Initialize preloaded assets
    // APP.managers.load.queueStrings( AssetDirectory.strings );
    // APP.managers.load.queueStrings( AssetDirectory.preloader_strings );
    // APP.managers.load.queueFonts( AssetDirectory.fonts );
    // APP.managers.load.queueImages( AssetDirectory.preloader_ui );
    APP.managers.load.queueAssets(AssetDirectory.preload);

    APP.managers.load.start(function () {

        var promises = [];

        this.fontObserve = [];
        for (var i = 0; i < EHDI.Assets.fonts.length; i++) {
            this.fontObserve[i] = new FontFaceObserver(EHDI.Assets.fonts[i]);
            promises.push(this.fontObserve[i].load());
        }
        Promise.all(promises)
            .then(function () {

                // Change to preloader
                APP.managers.scene.changeScene(new APP.scenes.PreloaderScene());

                // Call resize callback
                Main.onResize();
            })
    });

    // this.destroy = function () {
    //    APP.managers.update.removeAllFrameListeners();
    //    APP.managers.scene.destroy();
    // }

    EHDI.restart = function () {
        if (APP.scenes.GameScene) {
            // Restart
            APP.scenes.GameScene.restart();
        }
    }

    EHDI.destroy = function () {
        APP.managers.sound.stopBGM()
        if (EHDI.GAME.GameScene) {
            EHDI.GAME.GameScene.dispose();
        }
        if (APP.managers.update) {
            APP.managers.update.removeAllFrameListeners();
            APP.managers.update.deleteUpdateManager();
        }
        Main.vendorGameElement.removeChild(Main.canvas)
        document.body.removeChild(Main.vendorGameElement);

        if (APP.managers.scene) APP.managers.scene.destroy();
        if (APP.managers.scale) APP.managers.scale.destroy();
    }
};

// Main onLoad function
Main.onLoad = function () {

    EHDI.GAME = EHDI.GAME || Object.create(null);
    EHDI.GAME.language = 'en';
    EHDI.GAME.id = gameId;

    // Create div element
    Main.vendorGameElement = document.createElement("div");
    Main.vendorGameElement.style.width = window.innerWidth;
    Main.vendorGameElement.style.height = window.innerHeight;
    Main.vendorGameElement.style.backgroundColor = '#0c3f76';
    document.body.style.backgroundColor = '#0c3f76';
    document.body.appendChild(Main.vendorGameElement);

    if (PIXI.VERSION[0] == '4') {
        // Set canvas to Main ajdnput on div
        Main.canvas = document.createElement("canvas");
        Main.canvas.id = "game-canvas";
        Main.canvas.width = Main.vendorGameElement.style.width;
        Main.canvas.height = Main.vendorGameElement.style.height;
        Main.vendorGameElement.appendChild(Main.canvas);
    }
    else {
        console.log('version 5');
    }

    // Create GameInit instance
    // TODO: Set to Main.gameInit or some global variable to call destroy function from outside
    Main.gameInit = new GameInit("full", Main.vendorGameElement, function () { console.log("Level Complete") }, null, null, true, true, true);

    Main.onResize();
    // Add resize listener
    window.addEventListener("resize", Main.onResize);
};

// Prevent default on window touch move
/*
document.ontouchmove = function (e) {
    e.preventDefault();
    window.scrollTo(0, 0);
};
*/

// Set on load function
window.onload = Main.onLoad;
